//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    checked: Boolean,
    checkboxData: {
      type: Object,
      required: true
    },
    isSingle: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    toggleCheck (event, checkboxData) {
      this.$emit('change', event.target.checked)
      this.$emit('filterOut', checkboxData)
    }
  }
}
